// Round S — mirrors game_scoring.scoring_word_count (Python: [^\W_]+(?:['’\-][^\W_]+)*).
export const DEFAULT_MIN_SCORING_WORDS = 25;
const WORD_RE = /[\p{L}\p{N}]+(?:['’-][\p{L}\p{N}]+)*/gu;

export const countScoringWords = (text) => (String(text || "").match(WORD_RE) || []).length;

export const minScoringWords = (week) => {
  const n = week?.min_scoring_words;
  return Number.isInteger(n) && n > 0 ? n : DEFAULT_MIN_SCORING_WORDS;
};

const woorden = (n) => `${n} ${n === 1 ? "woord" : "woorden"}`;

// -> { state: "no_question" | "too_short" | "scores", text, double }
export const scoringHint = ({ text, questionId, questionCategory, focusCategory, min }) => {
  if (!questionId) {
    return { state: "no_question", double: false,
      text: "Losse memo — telt niet mee voor de weekstand. Kies een vraag om punten te halen." };
  }
  const words = countScoringWords(text);
  if (words < min) {
    return { state: "too_short", double: false,
      text: `${woorden(words)} — vanaf ${min} telt dit mee voor de weekstand. Vul aan of spreek opnieuw in.` };
  }
  const double = !!focusCategory && questionCategory === focusCategory;
  return { state: "scores", double, text: `Telt mee voor de weekstand${double ? " · dubbel" : ""}` };
};

export const zeroPointsMessage = (reward) => {
  if (!reward || reward.points > 0) return null;
  if (reward.reason === "too_short") {
    const min = reward.min_words || DEFAULT_MIN_SCORING_WORDS;
    return `Telt niet mee voor de weekstand: ${reward.word_count ?? 0} van de ${min} woorden. Een paar zinnen meer en hij telt wel.`;
  }
  if (reward.reason === "no_question") {
    return "Losse memo — telt niet mee voor de weekstand. Alleen antwoorden op een vraag leveren punten op.";
  }
  return null;
};
